import { WeatherStationObservationDataKey } from 'features/weatherStations/weatherStations.types';
import { localStorageEffect } from 'libs/recoil';
import { useCallback } from 'react';
import { atom, useRecoilState } from 'recoil';

export type FocusedSensorType = Exclude<
  WeatherStationObservationDataKey,
  'windDirectionToward'
>;

type WeatherStationState = {
  focusedSensorType: FocusedSensorType;
};

type UseWeatherStationState = WeatherStationState & {
  setFocusedSensorType: (focusedSensorType: FocusedSensorType) => void;
};

const weatherStationStateAtom = atom<WeatherStationState>({
  key: 'WEATHER_STATION_STATE',
  default: {
    focusedSensorType: 'airTemp',
  },
  effects: [localStorageEffect('WEATHER_STATION_STATE')],
});

export const useWeatherStationState = (): UseWeatherStationState => {
  const [weatherStationState, setWeatherStationState] = useRecoilState(
    weatherStationStateAtom,
  );

  const setFocusedSensorType = useCallback(
    (focusedSensorType: FocusedSensorType) => {
      setWeatherStationState((prevState) => ({
        ...prevState,
        focusedSensorType,
      }));
    },
    [setWeatherStationState],
  );

  return {
    ...weatherStationState,
    setFocusedSensorType,
  };
};
